import push from './push';
import pushToFirst from './pushToFirst';
import filter from './filter';
import remove from './remove';

export default {
  push,
  pushToFirst,
  filter,
  remove,
};



// WEBPACK FOOTER //
// ./src/actions/array/index.js